// Helper functions for common operations

export const getSubscriptionStatusColor = (status: string): string => {
  const statusColors: Record<string, string> = {
    active: 'bg-green-100 text-green-800',
    inactive: 'bg-red-100 text-red-800',
    expired: 'bg-yellow-100 text-yellow-800',
    pending: 'bg-blue-100 text-blue-800'
  };
  return statusColors[status] || 'bg-gray-100 text-gray-800';
};

export const getSubscriptionStatusLabel = (status: string): string => {
  const statusLabels: Record<string, string> = {
    active: 'Active',
    inactive: 'Inactive',
    expired: 'Expired',
    pending: 'Pending'
  };
  return statusLabels[status] || status;
};

export const getUserRoleColor = (role: string): string => {
  const roleColors: Record<string, string> = {
    'admin': 'bg-red-100 text-red-800',
    'manager': 'bg-blue-100 text-blue-800',
    'cashier': 'bg-green-100 text-green-800',
    'staff': 'bg-gray-100 text-gray-800'
  };
  return roleColors[role] || 'bg-gray-100 text-gray-800';
};

export const getUserRoleLabel = (role: string): string => {
  const roleLabels: Record<string, string> = {
    'admin': 'Administrator',
    'manager': 'Manager',
    'cashier': 'Cashier',
    'staff': 'Staff'
  };
  return roleLabels[role] || role;
};

export const getBranchModeColor = (mode: string): string => {
  const modeColors: Record<string, string> = {
    'fnb': 'bg-blue-100 text-blue-800',
    'retail': 'bg-green-100 text-green-800',
    'hybrid': 'bg-purple-100 text-purple-800'
  };
  return modeColors[mode] || 'bg-gray-100 text-gray-800';
};

export const getBranchModeLabel = (mode: string): string => {
  const modeLabels: Record<string, string> = {
    'fnb': 'Food & Beverage',
    'retail': 'Retail',
    'hybrid': 'Hybrid'
  };
  return modeLabels[mode] || mode;
};

export const getBusinessTypeColor = (type: string): string => {
  return type === 'fnb' 
    ? 'bg-blue-100 text-blue-800' 
    : 'bg-green-100 text-green-800';
};

export const getBusinessTypeLabel = (type: string): string => {
  return type === 'fnb' ? 'F&B' : 'Retail';
};

export const getProductTypeLabel = (type: string): string => {
  const typeLabels: Record<string, string> = {
    'finished_good': 'Finished Good',
    'raw_material': 'Raw Material',
    'semi_finished': 'Semi-Finished',
    'service': 'Service',
    'bundle': 'Bundle'
  };
  return typeLabels[type] || type;
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString('id-ID', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) => {
  let timeout: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};
